<template>
    <div>
        <p class="text-guide">
            {{ $t('paragraphs.referer_check_tip_1')}}<br>
            {{ $t('paragraphs.referer_check_tip_2')}}<br>
            {{ $t('paragraphs.referer_check_tip_3')}}
        </p>
        <div>
            <div v-if="haveSubmitRight" class="text-right mb-3">
                <button class="btn btn-primary" @click="doSaveReferer()">{{ $t('words.save') }}</button>
            </div>
            <div class="form-group row">
                <label class="col-md-3">{{ $t('words.referer_config') }}</label>
                <div class="col-md-9">
                    <div class="form-radio">
                        <input type="radio" :value="0" id="use_referer_check_0" name="use_referer_check" :disabled="!haveSubmitRight" v-model="use_referer_check">
                        <label for="use_referer_check_0">{{ $t('words.referer_check_option_disable') }}</label>
                    </div>
                    <div class="form-radio">
                        <input type="radio" :value="1" id="use_referer_check_1" name="use_referer_check" :disabled="!haveSubmitRight" v-model="use_referer_check">
                        <label for="use_referer_check_1">{{ $t('words.referer_check_option_check') }}</label>
                    </div>
                    <div class="form-radio">
                        <input type="radio" :value="2" id="use_referer_check_2" name="use_referer_check" :disabled="!haveSubmitRight" v-model="use_referer_check">
                        <label for="use_referer_check_2">{{ $t('words.referer_check_option_reject') }}</label>
                    </div>
                    <span class="invalid-feedback" v-if="meta.errors.use_referer_check" v-for="error in meta.errors.use_referer_check" :key="error">{{ error }}</span>
                </div>
            </div>
            <div class="form-group row" v-if="use_referer_check !== 0">
                <label class="col-md-3" v-if="use_referer_check===1">{{ $t('words.referer_check_domains') }}</label>
                <label class="col-md-3" v-if="use_referer_check===2">{{ $t('words.referer_reject_domains') }}</label>
                <table class="col-md-6 table">
                    <colgroup>
                        <col>
                        <col width="15%">
                    </colgroup>
                    <thead>
                    <tr>
                        <th>{{ $t('words.domain') }}</th>
                        <th>{{ $t('words.remove') }}</th>
                    </tr>
                    </thead>
                    <tbody v-if="referer_domains.length > 0">
                    <tr v-for="referer in referer_domains">
                        <td style="word-break: break-all">
                            {{ referer }}
                        </td>
                        <td class="text-right" style="white-space: nowrap">
                            <button class="btn btn-icon btn-flat" v-if="haveSubmitRight" @click="doRemove(referer)" >
                                <i class="icon icon-trash"></i>
                            </button>
                        </td>
                    </tr>
                    </tbody>
                    <tbody v-else>
                    <tr>
                        <td class="td__message"  :colspan="2">
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 24 24" class="svg-icon svg-icon-alert-circle"><g stroke-linecap="square" stroke-linejoin="miter" stroke-width="2" fill="#adb5bd" stroke="#adb5bd"><circle fill="none" stroke="#adb5bd" stroke-miterlimit="10" cx="12" cy="12" r="11"/> <line data-color="color-2" fill="none" stroke-miterlimit="10" x1="12" y1="7" x2="12" y2="13"/> <circle data-color="color-2" data-stroke="none" cx="12" cy="17" r="1" stroke-linejoin="miter" stroke-linecap="square" stroke="none"/></g></svg>{{ $t('paragraphs.list_empty') }}</td>
                    </tr>
                    </tbody>
                </table>
                <div class="col-md-6 offset-3 input-group mt-3">
                    <input type="text" name="domain" class="form-control" v-model="domain" @keyup.enter="doAppend()"/>
                    <div class="input-group-append">
                        <button class="btn" @click="doAppend()" v-if="haveSubmitRight">
                            {{ $t('words.add') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import GlobalConfigMixin from '../../mixin/GlobalConfigMixin';

export default {
    mixins: [
        GlobalConfigMixin,
    ],
    props: {
        channel: {
            type: [Object],
            require: true,
        },
        modifyMode: {
            type: [Boolean],
            require: true,
        },
        currentTab: {
            type: [String],
            require: true,
        },
    },
    data() {
        return {
            tab_name: 'referer',
            use_referer_check: 0,
            domain: '',
            referer_domains: [],
            trans_referer_domains: [],
            referer_checks: [],
            referer_rejects: [],
            meta: {
                errors: {},
            },
        };
    },
    methods: {
        initial() {
            this.use_referer_check = this.channel.use_referer_check;
            this.referer_rejects = this.channel.referer_reject_domains.split(',');
            this.referer_checks = this.channel.referer_check_domains.split(',');
            this.setRefererData();
        },
        setRefererData() {
            if (this.use_referer_check === 0) {
                this.referer_checks = [];
                this.referer_rejects = [];
                this.referer_domains = [];
            } else if (this.use_referer_check === 1) {
                this.referer_domains = this.referer_checks;
                this.referer_rejects = [];
            } else if (this.use_referer_check === 2) {
                this.referer_domains = this.referer_rejects;
                this.referer_checks = [];
            }
            this.setTransRefererDomains();
        },
        setTransRefererDomains() {
            this.trans_referer_domains = [];
            _.forEach(_.split(this.referer_domains, ','), (item) => {
                _.forEach(_.split(_.trim(item), ','), (sub) => {
                    const subItem = _.trim(sub);
                    if (subItem !== '') {
                        this.trans_referer_domains.push(subItem);
                    }
                });
            });
        },
        getRefererData() {
            if (this.use_referer_check === 0) {
                this.referer_checks = [];
                this.referer_rejects = [];
            } else if (this.use_referer_check === 1) {
                this.referer_checks = this.referer_domains;
                this.referer_rejects = [];
            } else if (this.use_referer_check === 2) {
                this.referer_rejects = this.referer_domains;
                this.referer_checks = [];
            }

            return {
                use_referer_check: this.use_referer_check,
                referer_check_domains: this.referer_checks.join(','),
                referer_reject_domains: this.referer_rejects.join(','),
            };
        },
        checkInReferer(str) {
            const refererArr = str.split(',');
            let refererIn = false;
            _.forEach(refererArr, (referer) => {
                const search = _.find(this.trans_referer_domains, item => referer.trim() === item.trim());
                if (typeof search !== 'undefined') {
                    this.$toasted.error(this.$t('paragraphs.message.error.exist_in_referer_domains'));
                    refererIn = true;
                    return false;
                }
            });
            if (refererIn) return false;
            return true;
        },
        doAppend() {
            if (!this.haveSubmitRight) {
                return;
            }
            if (this.domain.length === 0) {
                this.$toasted.error(this.$t('paragraphs.message.error.empty_domain'));
                return;
            }
            if (!this.checkInReferer(this.domain)) {
                return;
            }
            this.referer_domains.push(this.domain);
            this.domain = '';
            this.setTransRefererDomains();
        },
        doRemove(referer) {
            _.pull(this.referer_domains, referer);
            this.setTransRefererDomains();
            this.$forceUpdate();    // re rendering table
        },
        doSaveReferer() {
            if (!this.haveSubmitRight) {
                this.$toasted.error(this.$t('paragraphs.error.check_login_right'));
                return;
            }
            if (this.use_referer_check !== 0) {
                if (this.referer_domains.length === 0) {
                    if (this.use_referer_check === 1) {
                        this.$toasted.error(this.$t('paragraphs.message.error.empty_check_domains'));
                    } else if (this.use_referer_check === 2) {
                        this.$toasted.error(this.$t('paragraphs.message.error.empty_reject_domains'));
                    }
                    return;
                }
            }
            let confirmMessage;
            if (this.modifyMode) {
                confirmMessage = this.$t('paragraphs.message.confirm.update_item');
            } else {
                confirmMessage = this.$t('paragraphs.message.confirm.create_item');
            }
            const payload = this.getRefererData();
            if (confirm(confirmMessage)) {
                this.meta.errors = {};
                axios.patch(`${this.channelApiUri}/${this.channel.id}`, payload).then(() => {
                    this.$emit('changedReferer', payload);
                    this.$toasted.success(this.$t('paragraphs.message.success.change'));
                }).catch((error) => {
                    this.meta.errors = error.response.data.errors;
                    if (this.meta.errors.referer_check_domains) {
                        this.$toasted.error(this.meta.errors.referer_check_domains);
                    } else if (this.meta.errors.referer_reject_domains) {
                        this.$toasted.error(this.meta.errors.referer_reject_domains);
                    } else {
                        this.$toasted.error(this.$t('paragraphs.message.error.change'));
                    }
                });
            }
        },
    },
    computed: {
        channelApiUri() {
            return `/cms/${this.selectedServiceAccount.key}/channels`;
        },
        haveSubmitRight() {
            return (!this.modifyMode && this.haveOwnerRight) || (this.modifyMode && this.haveManagerRight);
        },
        loadedChannel() {
            return this.loadedServiceAccount && ('id' in this.channel) && (this.channel.id !== '');
        },
        selectedTab() {
            return this.loadedChannel && this.currentTab === this.tab_name;
        },
    },
    watch: {
        selectedTab(newValue) {
            if (newValue) {
                this.initial();
            }
        },
        use_referer_check(newValue, oldValue) {
            // 옵션을 바꾸더라도 데이터는 삭제하지 않도록 한다.
            if (this.use_referer_check === 0) {
                // this.referer_checks = [];
                // this.referer_rejects = [];
                this.referer_domains = [];
            } else if (this.use_referer_check === 1) {
                this.referer_domains = this.referer_checks;
                // this.referer_rejects = [];
            } else if (this.use_referer_check === 2) {
                this.referer_domains = this.referer_rejects;
                // this.referer_checks = [];
            }
            this.setTransRefererDomains();
            // this.setRefererData();
        },
    },
};

</script>
